import { render, staticRenderFns } from "./BeeDatatable.vue?vue&type=template&id=40ba9136"
import script from "./BeeDatatable.vue?vue&type=script&lang=js"
export * from "./BeeDatatable.vue?vue&type=script&lang=js"
import style0 from "./BeeDatatable.vue?vue&type=style&index=0&id=40ba9136&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports